module.exports = __webpack_public_path__ + "img/terms.43e59c3d.svg";